import React from 'react';
import { Html5QrcodeScanner } from 'html5-qrcode';
import { useFlag } from '@unleash/proxy-client-react';
import CloseableModal from 'Components/CloseableModal';
import { FeatureFlagEnums } from '@ssg/common/FeatureFlagEnums';
import { Html5QrcodeScannerStrings } from 'html5-qrcode/esm/strings';
export interface Props {
	onDismiss: () => void;
	onScanSuccess: (id: string) => void;
}

Html5QrcodeScannerStrings.torchOffButton = function () {
	return 'Sluk for lygte';
};
Html5QrcodeScannerStrings.torchOnButton = function () {
	return 'Tænd for lygte';
};

Html5QrcodeScannerStrings.cameraPermissionTitle = function () {
	return 'Bed om tilladelse til at bruge kameraet';
};
Html5QrcodeScannerStrings.cameraPermissionRequesting = function () {
	return 'Beder om tilladelse ...';
};

Html5QrcodeScannerStrings.selectCamera = function () {
	return 'Vælg kamera';
};

const NOT_FOUND = 'SCANNED_TEXT_NOT_FOUND';

const ScannerModal: React.FC<Props> = ({ onDismiss, onScanSuccess }) => {
	const [data, setData] = React.useState(NOT_FOUND);
	const [html5QrcodeScanner, setHtml5QrcodeScanner] = React.useState<Html5QrcodeScanner>();

	const enabled = useFlag(FeatureFlagEnums.SCANNER_LIGHT);

	React.useEffect(() => {
		return () => {
			html5QrcodeScanner?.clear();
		};
	}, [html5QrcodeScanner]);

	React.useEffect(() => {
		if (data !== NOT_FOUND) {
			onScanSuccess(data.replace('ma:', '').replace('/', '-'));
		}
	}, [data, onScanSuccess]);

	const successHandler = React.useCallback(async (scannedString: string) => {
		console.log('id:', scannedString);

		setData(scannedString);
	}, []);

	React.useEffect(() => {
		if (typeof html5QrcodeScanner === 'undefined') {
			const newHtml5QrcodeScanner = new Html5QrcodeScanner(
				'reader',
				{
					fps: 10,
					qrbox: { width: 250, height: 250 },
					supportedScanTypes: [],
					showTorchButtonIfSupported: enabled,
				},
				/* verbose= */ false,
			);
			setHtml5QrcodeScanner(newHtml5QrcodeScanner);
		}
		if (typeof html5QrcodeScanner !== 'undefined') {
			html5QrcodeScanner.render(
				(data: string) => successHandler(data),
				(err: string) => console.log('err ->', err),
			);
		}
	}, [enabled, html5QrcodeScanner, successHandler]);

	React.useEffect(() => {
		const torchButton = document.getElementById('html5-qrcode-button-torch');
		if (torchButton) {
			torchButton.innerHTML = 'Tænd for lygte';
			const handleClick = () => {
				torchButton.innerHTML = torchButton.innerHTML === 'Tænd for lygte' ? 'Sluk for lygte' : 'Tænd for lygte';
			};
			torchButton.addEventListener('click', handleClick);
			return () => torchButton.removeEventListener('click', handleClick);
		}
	}, []);

	return (
		<CloseableModal title="Scanning label" onDismiss={onDismiss}>
			<div className="mx-auto" style={{ width: 500, height: 600 }}>
				<div style={{ width: '500px' }} id="reader"></div>
			</div>
		</CloseableModal>
	);
};

export default ScannerModal;

